<div class="text-align-center display-flex flex-direction-column">
  <sb-stamp class="mb-4 mh-auto" [type]="'dimmed-blue'">
    <sb-icon [name]="'doublecheck'" [size]="'3'" />
  </sb-stamp>
  <h3 class="t-5@r color-void mb-3@r">{{ headlineCopy }}</h3>

  <div class="t-8@r color-ash">
    {{ bodyCopy }}
  </div>

  <button class="mt-6" sbButton [size]="'big'" [variant]="'fill-gold'" (click)="confirm()">Unlock</button>
</div>
